<template>
  <div class="contents contents--full">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>{{checkUserId.organizationName}}의 품질평가 결과</h3>
        <button @click="downloadExcel" class="excel-download-btn" v-if="checkUserId.privilege != 'user'" >엑셀 다운로드</button>
        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>품질평가 결과</span>
        </div>
      </div>

      <div class="summary-table-container">

        <table class="summary-table" v-if="checkUserId.privilege != 'user'">
          <thead>
            <tr>
              <th rowspan="2" @click="resetFilter">기관 구분</th>
              <th rowspan="2" @click="resetFilter">품질평가 총점</th>
              <template v-for="(domain, index) in transformedDomains" :key="`header-${index}`">
                <th @click="filterByDomain(domain.domainCode)">
                  {{ domain.domainName.split('(')[0] }}
                  <br />({{ domain.domainName.match(/\((.*?)\)/)?.[1] || '' }})
                </th>
              </template>
            </tr>
          </thead>
    
          <tbody>
            <tr>
              <td >
                {{checkUserId.organizationName}}
              </td>
              <!-- 품질평가 총점 -->
              <td :class="getScoreClass(calculateFinalScore())">
                {{ calculateFinalScore() || 0.00 }}
              </td>
              <!-- 각 도메인 점수 -->
              <template v-for="(domain, index) in transformedDomains" :key="`score-${index}`">
                <td :class="getScoreClass(calculateDomainScore1(domain.domainCode))">
                  {{ calculateDomainScore1(domain.domainCode) || 0.00}}
                </td>
              </template>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <td>타기관</td>
              <!-- 품질평가 총점 -->
              
              <td :class="getScoreClass(anotherFinalScore)">
                {{ anotherFinalScore || 0.00 }}
              </td>
             
              <!-- 각 도메인 점수 -->
              <template v-for="(domain, index) in transformedDomains" :key="`domain-score-${index}`">
                <td :class="getScoreClass(anotherDomainScore1(domain.domainCode))">
                  {{ anotherDomainScore1(domain.domainCode) || 0.00 }}
                </td>
              </template>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <td>차이</td>
              <!-- 품질평가 총점 차이 -->
              <td>
                {{ totalScoreDifference || 0.00 }}
              </td>
              <!-- 각 도메인 점수 차이 -->
              <template v-for="(domain, index) in transformedDomains" :key="`diff-score-${index}`">
                <td>
                  {{ domainScoreDifferences[domain.domainCode] || 0.00 }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>

        <span class="excel-announcement">※ 제시된 점수는 세부평가사항, Standard, Principle, Domain 등 평가체계의 단계별 가중치를 반영하여 산출한 최종 결과이며, 세부평가점수의 단순 합산값과는 다를 수 있습니다.</span>

        <br />
        <!-- 통계 테이블 -->
        <div class="stats-table-container">
          <table class="stats-table">

            <thead>
              <tr>
                <th>Domain</th>
                <th>Principle</th>
                <th>Standard</th>
                <th>세부평가코드</th>
                <!-- <th>세부평가사항</th>
                <th>세부평가점수</th> -->
                <th>Standard 점수</th>
                <th v-if="checkUserId.privilege != 'user'">타기관 Standard 점수</th>
                <th>Principle 점수</th>
                <th v-if="checkUserId.privilege != 'user'">타기관 Principle 점수</th>
                <th>Domain 점수</th>
                <th v-if="checkUserId.privilege != 'user'">타기관 Domain 점수</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(domain, domainIndex) in sortedFilteredDomains" :key="domainIndex">
                <template v-for="(principle, principleIndex) in domain.principles" :key="principleIndex">
                  <template v-for="(standard, standardIndex) in principle.standards" :key="standardIndex">
                    <template v-for="(evaluation, evalIndex) in standard.evaluations" :key="evalIndex">
                      <tr>
                        <!-- Domain -->
                        <td v-if="principleIndex === 0 && standardIndex === 0 && evalIndex === 0" 
                            :rowspan="getDomainRowspan(domain)" 
                            v-html="formatName(domain.domainName)">
                        </td>
                        <!-- Principle -->
                        <td v-if="standardIndex === 0 && evalIndex === 0" 
                            :rowspan="getPrincipleRowspan(principle)" 
                            v-html="formatName(principle.principleName)">
                        </td>
                        <!-- Standard -->
                        <td v-if="evalIndex === 0" 
                            :rowspan="standard.evaluations.length" 
                            v-html="formatName(standard.standardName)">
                        </td>
                        <!-- Evaluation -->
                        <td>{{ evaluation.evaluationCode }}</td>
                        <!-- <td>{{ evaluation.evaluationName }}</td> -->
                        <!-- <td>{{ evaluationScores[evaluation.evaluationCode] || 0.00 }}</td> -->
                        <!-- Standard 가중치 -->
                        <td v-if="evalIndex === 0" 
                            :rowspan="standard.evaluations.length"
                            :class="getScoreClassWithComparison(calculateStandardScore1(standard.standardCode || 'A'), anotherStandardScore1(standard.standardCode || 'A'))">
                          {{ calculateStandardScore1(standard.standardCode || 'A') }}
                        </td>
                        <td v-if="evalIndex === 0 && checkUserId.privilege != 'user'" 
                            :rowspan="standard.evaluations.length" 
                            class="avg-score">
                          {{ anotherStandardScore1(standard.standardCode || 'A') }}
                        </td>

                        <!-- Principle 가중치 -->
                        <td v-if="standardIndex === 0 && evalIndex === 0" 
                            :rowspan="getPrincipleRowspan(principle)"
                            :class="getScoreClassWithComparison(calculatePrincipleScore1(principle.principleCode || 'A'), anotherPrincipleScore1(principle.principleCode || 'A'))">
                          {{ calculatePrincipleScore1(principle.principleCode || 'A') }}
                        </td>
                        <td v-if="standardIndex === 0 && evalIndex === 0 && checkUserId.privilege != 'user'" 
                            :rowspan="getPrincipleRowspan(principle)" 
                            class="avg-score">
                          {{ anotherPrincipleScore1(principle.principleCode || 'A') }}
                        </td>

                        <!-- Domain 가중치 -->
                        <td v-if="principleIndex === 0 && standardIndex === 0 && evalIndex === 0" 
                            :rowspan="getDomainRowspan(domain)"
                            :class="getScoreClassWithComparison(calculateDomainScore1(domain.domainCode), anotherDomainScore1(domain.domainCode))">
                          {{ calculateDomainScore1(domain.domainCode) || 0.00 }}
                        </td>
                        <td v-if="principleIndex === 0 && standardIndex === 0 && evalIndex === 0 && checkUserId.privilege != 'user'" 
                            :rowspan="getDomainRowspan(domain)" 
                            class="avg-score">
                          {{ anotherDomainScore1(domain.domainCode) || 0.00 }}
                        </td>

                      </tr>
                    </template>
                  </template>
                </template>
              </template>
            </tbody>



          </table>
        </div>
      </div>
    </div>
  </div>

</template>


<script setup>
import { reactive, ref, computed, onMounted,onUnmounted  } from "vue";
import { useStore } from "vuex";
import { useRouter,useRoute } from 'vue-router'
import * as XLSX from "xlsx";
const store = useStore();
const route = useRoute()
// 필터링 상태
const selectedDomainCode = ref(null);

// 도메인 데이터 가져오기
const domainList = computed(() => store.state.grid.domainData);// 도메인 데이터 가져오기
const orgEvlList = computed(() => store.state.grid.evlOrgData2);// 평가데이터 가져오기기
const anotherEvlList = computed(() => store.state.grid.evlOrgData);// 평가데이터 가져오기기

const giasAvgList = computed(() => store.state.grid.evlAvgData); // 기업별 통계 요약 안씀
const giasAllAvgList = computed(() => store.state.grid.evlAvgAllData);// 모든기업별 통계 오약
const gias3YearAvgList = computed(() => store.state.grid.evl3YearAvgData);// 3년치 평가점수
const checkUserId = computed(() => store.state.temp.userInfo);


// 평가 점수 매핑
const evaluationScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.evaluationCode && item.evaluationScore) {
      scores[item.evaluationCode] = item.evaluationScore;
    }
  });
  return scores;
});

const eqcComments = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.evaluationCode && item.eqcComment) {
      scores[item.evaluationCode] = item.eqcComment;
    }
  });
  return scores;
});

// 현황 매핑핑
const evaluationCurrents = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.evaluationCode && item.evaluationCurrent) {
      scores[item.evaluationCode] = item.evaluationCurrent;
    }
  });
  return scores;
});

// 개선사항 매핑
const evaluationImps = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.evaluationCode && item.evaluationImp) {
      scores[item.evaluationCode] = item.evaluationImp;
    }
  });
  return scores;
});

// Standard 1 점수 매핑
const standardScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.standardCode && item.standardScore1) { // 🔹 Standard 1 점수 매핑
      scores[item.standardCode] = item.standardScore1;
    }
  });
  return scores;
});


// Standard 1 점수를 그대로 반환하는 함수
const calculateStandardScore1 = (standardCode) => {
  return standardScores.value[standardCode] ? standardScores.value[standardCode].toFixed(2) : 0.00;
};

// 타기관 스탠다드 평균 점수 매핑
const anotherStandardScores = computed(() => {
  const scores = {};
  anotherEvlList.value.forEach((item) => {
    if (item.standardCode && item.standardScore1) { // 🔹 Standard 1 점수 매핑
      scores[item.standardCode] = item.standardScore1;
    }
  });
  return scores;
});


// 타기관 스탠다드 평균
const anotherStandardScore1 = (standardCode) => {
  return anotherStandardScores.value[standardCode] ? anotherStandardScores.value[standardCode].toFixed(2) : 0.00;
};


// Principle 1 점수 매핑
const anotherPrincipleScores = computed(() => {
  const scores = {};
  anotherEvlList.value.forEach((item) => {
    if (item.principleCode && item.principleScore1 !== undefined) { // 🔹 null 방지
      scores[item.principleCode] = item.principleScore1;
    }
  });
  return scores;
});

// Principle 1 점수 조회 함수
const anotherPrincipleScore1 = (principleCode) => {
  if (!principleCode || !anotherPrincipleScores.value[principleCode]) {
    return 0.00;
  }
  return anotherPrincipleScores.value[principleCode].toFixed(2);
};


// Principle 1 점수 매핑
const principleScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.principleCode && item.principleScore1 !== undefined) { // 🔹 null 방지
      scores[item.principleCode] = item.principleScore1;
    }
  });
  return scores;
});


// Principle 1 점수 조회 함수
const calculatePrincipleScore1 = (principleCode) => {
  if (!principleCode || !principleScores.value[principleCode]) {
    return 0.00;
  }
  return principleScores.value[principleCode].toFixed(2);
};


// ✅ Domain 점수 매핑
const domainScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.domainCode && item.domainScore1 !== undefined) {
      scores[item.domainCode] = item.domainScore1;
    }
  });
  //console.log("🔹 domainScores 데이터 확인:", scores); // 🔍 디버깅 로그
  return scores;
});

// ✅ Domain 점수 매핑
const avgDomainScores = computed(() => {
  const scores = {};
  orgEvlList.value.forEach((item) => {
    if (item.domainCode && item.avgDomainScore !== undefined) {
      scores[item.domainCode] = item.avgDomainScore;
    }
  });
 
  return scores;
});

// 타기관 도메인 점수 매핑
const anotherDomainScores = computed(() => {
  const scores = {};
  anotherEvlList.value.forEach((item) => {
    if (item.domainCode && item.domainScore1 !== undefined) {
      scores[item.domainCode] = item.domainScore1;
    }
  });
 
  return scores;
});

const anotherDomainScore1 = (domainCode) => {
  return anotherDomainScores.value[domainCode]?.toFixed(2) || '0.00';
};

// totalAvgDomainScore
const anotherFinalScore = computed(() => {
  let score = null;
  
  // API 데이터에서 finalScore 값을 찾음
  if (anotherEvlList.value.length > 0) {
    score = anotherEvlList.value[0]?.finalScore; // 첫 번째 항목에서 최종 점수 가져오기
  }

  //console.log("🔹 finalScore 데이터 확인:", score); // 🔍 디버깅 로그
  return Number(score).toFixed(2);
});


const totalAvgDomainScore = computed(() => {
  const scores = Object.values(avgDomainScores.value); // 모든 도메인 점수를 배열로 변환
  if (scores.length === 0) return 0.00; // 데이터가 없으면 0.00 반환

  const totalSum = scores.reduce((sum, score) => sum + (score || 0), 0); // null값 방지
  return (totalSum / scores.length).toFixed(2); // 평균값 반환 (소수점 2자리)
});


const calculateDomainScore1 = (domainCode) => {
  //console.log("domainCode : " + domainCode)
  return domainScores.value[domainCode]?.toFixed(2) || '0.00';
};

// ✅ Final Score (최종 점수) 매핑
const finalScore = computed(() => {
  let score = null;
  
  // API 데이터에서 finalScore 값을 찾음
  if (orgEvlList.value.length > 0) {
    score = orgEvlList.value[0]?.finalScore; // 첫 번째 항목에서 최종 점수 가져오기
  }

  //console.log("🔹 finalScore 데이터 확인:", score); // 🔍 디버깅 로그
  return score;
});

// ✅ Final Score 조회 함수
const calculateFinalScore = () => {
  const score = Number(finalScore.value); // 🔥 숫자로 변환 (null → NaN 방지)
  return isNaN(score) ? "0.00" : score.toFixed(2); // 🔥 NaN 체크 후 기본값 설정
};

// 필터링된 도메인 데이터
const filteredDomains = computed(() => {
  if (!selectedDomainCode.value) {
    return transformedDomains.value; // 필터가 없을 때 전체 데이터 반환
  }
  return transformedDomains.value.filter(
    (domain) => domain.domainCode === selectedDomainCode.value
  );
});


const domainScoreDifferences = computed(() => {
  const differences = {};
  transformedDomains.value.forEach(domain => {
    const orgScore = calculateDomainScore1(domain.domainCode) || 0; // 해당 기관의 도메인 점수
    const avgScore = anotherDomainScore1(domain.domainCode) || 0; // 타기관 평균 도메인 점수
    differences[domain.domainCode] = (orgScore - avgScore).toFixed(2); // 차이 계산 (소수점 2자리)
  });
  return differences;
});

const totalScoreDifference = computed(() => {
  const orgTotal = calculateFinalScore() || 0;
  const avgTotal = anotherFinalScore.value || 0;
  return (orgTotal - avgTotal).toFixed(2);
});


// 통계 테이블 정렬된 데이터
const sortedFilteredDomains = computed(() => {
  return [...filteredDomains.value].sort((a, b) => {
    // Domain 코드가 "A"로 시작하는 경우를 우선 처리
    const aIsA = a.domainCode.startsWith('A');
    const bIsA = b.domainCode.startsWith('A');
    
    if (aIsA && !bIsA) return -1; // 'A'로 시작하는 도메인은 먼저
    if (!aIsA && bIsA) return 1; // 'A'로 시작하지 않는 도메인은 나중
    
    // 숫자 기반 정렬
    return a.domainCode.localeCompare(b.domainCode, undefined, { numeric: true });
  });
});


// 도메인 필터링 함수
const filterByDomain = (domainCode) => {
  selectedDomainCode.value = domainCode;
};

// 필터 초기화 함수
const resetFilter = () => {
  selectedDomainCode.value = null;
};


// 트리 구조 변환 함수
const transformToTreeStructure = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    if (!groupedData[item.domainCode]) {
      groupedData[item.domainCode] = {
        domainCode: item.domainCode,
        domainName: item.domainName,
        principles: {},
      };
    }
    const domain = groupedData[item.domainCode];

    if (!domain.principles[item.principleCode]) {
      domain.principles[item.principleCode] = {
        principleCode: item.principleCode,
        principleName: item.principleName,
        standards: {},
      };
    }
    const principle = domain.principles[item.principleCode];

    if (!principle.standards[item.standardCode]) {
      principle.standards[item.standardCode] = {
        standardCode: item.standardCode,
        standardName: item.standardName,
        evaluations: [],
      };
    }
    const standard = principle.standards[item.standardCode];

    standard.evaluations.push({
      evaluationCode: item.evaluationCode,
      evaluationName: item.evaluationName,
    });
  });

  return Object.values(groupedData).map((domain) => ({
    ...domain,
    principles: Object.values(domain.principles).map((principle) => ({
      ...principle,
      standards: Object.values(principle.standards),
    })),
  }));
};

// 트리 데이터 생성
const transformedDomains = computed(() => transformToTreeStructure(domainList.value));

// rowspan 계산
const getDomainRowspan = (domain) => {
  return domain.principles.reduce((total, principle) => {
    return total + principle.standards.reduce((count, standard) => count + standard.evaluations.length, 0);
  }, 0);
};

const sortedDomains = computed(() => {
  return [...transformedDomains.value].sort((a, b) => {
    const aStartsWithA = a.domainCode.match(/^[A]/); // A로 시작하는지 확인
    const bStartsWithA = b.domainCode.match(/^[A]/); // A로 시작하는지 확인

    if (aStartsWithA && !bStartsWithA) return -1; // A가 먼저
    if (!aStartsWithA && bStartsWithA) return 1; // A가 나중

    // A가 아니면 숫자 기반으로 정렬
    return a.domainCode.localeCompare(b.domainCode, undefined, { numeric: true });
  });
});

const downloadExcel = () => {
  const workbook = XLSX.utils.book_new();

  /** 📊 1. 통계 테이블 시트 생성 */
  const statsWorksheetData = [];
  const statsHeaders = [
    "Domain",
    "Principle",
    "Standard",
    "세부평가코드",
    "현황",
    "개선권고사항",
    "세부평가점수",
    "Standard 점수",
    "Principle 점수",
    "Domain 점수",
    "품질평가 총점"
  ];
  statsWorksheetData.push(statsHeaders);

  let currentRow = 1;
  let isFirstFinalScoreRow = true;  // ✅ finalScore가 첫 번째 행에만 들어가도록 체크

  const standardScoresMap = {};
  const principleScoresMap = {};
  const domainScoresMap = {};
  let finalScore = 0.00;

  orgEvlList.value.forEach((item) => {
    if (item.standardCode && item.standardScore1 !== undefined) {
      standardScoresMap[item.standardCode] = item.standardScore1;
    }
    if (item.principleCode && item.principleScore1 !== undefined) {
      principleScoresMap[item.principleCode] = item.principleScore1;
    }
    if (item.domainCode && item.domainScore1 !== undefined) {
      domainScoresMap[item.domainCode] = item.domainScore1;
    }
    if (item.finalScore !== undefined) {
      finalScore = item.finalScore.toFixed(2);
    }
  });

  sortedDomains.value.forEach(domain => {
    let isFirstDomainRow = true;

    domain.principles.forEach(principle => {
      let isFirstPrincipleRow = true;

      principle.standards.forEach(standard => {
        let isFirstStandardRow = true;

        standard.evaluations.forEach((evaluation, index) => {
          const row = [
            isFirstDomainRow ? domain.domainName : "",  // ✅ 첫 번째 행에만 입력
            isFirstPrincipleRow ? principle.principleName : "",
            isFirstStandardRow ? standard.standardName : "",
            evaluation.evaluationCode,
            evaluationCurrents.value[evaluation.evaluationCode] || 0.00,
            eqcComments.value[evaluation.evaluationCode] || 0.00,
            evaluationScores.value[evaluation.evaluationCode] || 0.00,
            isFirstStandardRow ? (standardScoresMap[standard.standardCode || "A"]?.toFixed(2) || 0.00) : "",
            isFirstPrincipleRow ? (principleScoresMap[principle.principleCode || "A"]?.toFixed(2) || 0.00) : "",
            isFirstDomainRow ? (domainScoresMap[domain.domainCode]?.toFixed(2) || 0.00) : "",
            isFirstFinalScoreRow ? finalScore : "" // ✅ 오직 첫 번째 행에만 finalScore 입력
          ];

          statsWorksheetData.push(row);
          currentRow++;

          isFirstDomainRow = false;  
          isFirstPrincipleRow = false;
          isFirstStandardRow = false;
          isFirstFinalScoreRow = false;  // ✅ finalScore를 입력했으므로 이후엔 빈 값 처리
        });
      });
    });
  });

  const statsWorksheet = XLSX.utils.aoa_to_sheet(statsWorksheetData);

  // ✅ 병합 없이 첫 번째 셀만 값 입력하여 병합된 효과를 줌
  XLSX.utils.book_append_sheet(workbook, statsWorksheet, "품질평가 결과");

  /** 📊 3. 엑셀 파일 생성 및 다운로드 */
  XLSX.writeFile(workbook, `${checkUserId.value.organizationName}_품질평가 결과.xlsx`);
};


const getPrincipleRowspan = (principle) => {
  return principle.standards.reduce((count, standard) => count + standard.evaluations.length, 0);
};

// 텍스트에 <br> 삽입하는 함수
const formatName = (name) => {
  if (!name) return "";
  return name.replace(/\(/g, "<br>("); // '(' 이전에 <br> 추가
};

// 요약 그리드 점수별로 배경색 바꾸기
const getScoreClass = (score) => {
  if (!score || score === 0.00) return "score-pending";
  if (score >= 80) return "score-excellent";
  if (score >= 60) return "score-satisfactory";
  if (score >= 40) return "score-needs-improvement";
  if (score >= 20) return "score-weak";
  return "score-very-weak";
};

const getScoreClassWithComparison = (score, avgScore) => {
  if (!score || score === 0.00) return ""; // 기본값 유지
  return score < avgScore ? "score-below-average" : ""; // 평균보다 낮으면 빨간색
};



// 모든 평가 항목 조회
const getGridData = async () => {
  if(checkUserId.value.privilege != 'user'){
    let param = {
      memberCode: checkUserId.value.memberCode,
    };
    await store.dispatch("grid/fetchAllDomain", param);
  }else{
    let param = {
      memberCode: checkUserId.value.memberCode,
    };
    await store.dispatch("grid/fetchDomain", param);
  }
};

// 저장한 평가 데이터 조회
const getEvlData = async () => {
  let param = {
    organizationCode: checkUserId.value.organizationCode,
    orgGiasYear : '2025'
  };
  //await store.dispatch("grid/fetchAdminEvlOrg2", param); fetchSelectGiasWeight
  await store.dispatch("grid/fetchSelectGiasWeight", param);
};

// 저장한 평가 데이터 조회
const getAnotherEvlData = async () => {
  let param = {
    organizationCode: checkUserId.value.organizationCode,
    orgGiasYear : '2025'
  };
  await store.dispatch("grid/fetchSelectAnotherOrgWeight", param);
};


onMounted(async () => {
  //console.log("기관이름" + orgName.value )
  await getGridData(); //메인 그리드 평가항목리스트
  await getEvlData(); // 평가항목에 저장된 점수를 조회
  await getAnotherEvlData();

});

// 컴포넌트 언마운트 시 호출
onUnmounted(() => {
  // Store의 clearEvlOrgData를 호출
  store.commit("grid/clearEvlOrgData2");
})
</script>


<style scoped>
.stats-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.stats-table th{
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center; /* 셀 텍스트 수평 중앙 정렬 */
  vertical-align: middle; /* 셀 텍스트 수직 중앙 정렬 */
  line-height: 1.6; /* 줄 간격 조정 */
  font-size: 12px;
}
.stats-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center; /* 셀 텍스트 수평 중앙 정렬 */
  vertical-align: middle; /* 셀 텍스트 수직 중앙 정렬 */
  line-height: 1.4;
  font-size: 10px;
}

.stats-table th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

.stats-table td {
  vertical-align: top;
}

/* 요약 테이블 스타일 */

.summary-table-container {
  background-color: white; /* 배경색 유지 */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
  border-bottom: 2px solid #ddd; /* 하단 테두리 */
  overflow: hidden; /* 전체 페이지 스크롤 제거 */
  display: flex;
  flex-direction: column;
}


.summary-table {
  position: sticky;
  top: 0; /* 화면 상단 고정 */
  z-index: 10; /* 통계 테이블보다 위에 배치 */
  background-color: white; /* 배경색 추가 */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
  border-bottom: 2px solid #ddd; /* 구분선 */
}

.summary-table th,
.summary-table td {
  border: 1px solid #000;
  padding: 10px;
}

/* 📌 고정된 영역이 상단에 가려지지 않도록 공간 추가 */
.container {
  padding-top: 60px; /* 요약 테이블 높이만큼 패딩 추가 */
}

.summary-table .highlight {
  background-color: #00a651;
  color: #fff;
  font-weight: bold;
}


/* 점수에 따른 배경색 */
.score-excellent {
  background-color: #00a651; /* 매우 충족 - 초록 */
  color: white;
}

.score-satisfactory {
  background-color: #92d050; /* 충족 - 연두 */
  color: black;
}

.score-needs-improvement {
  background-color: #ffff00; /* 개선여지 - 노랑 */
  color: black;
}

.score-weak {
  background-color: #ffc000; /* 취약 - 주황 */
  color: black;
}

.score-very-weak {
  background-color: #ff0000; /* 매우 취약 - 빨강 */
  color: white;
}

.score-pending {
  background-color: #eaeaea; /* 평가중 - 회색 */
  color: black;
}

/**  통계 데이터의 헤더가 따라옴*/
.stats-table thead tr {
  z-index: 5; /* 요약 테이블보다 아래에 위치 */
  background-color: #f4f4f4; /* 배경색 (겹치는 부분 가독성) */
  border-bottom: 2px solid #ddd; /* 헤더 하단 선 */
  padding: 8px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

.excel-download-container {
  position: fixed; /* 고정 위치 설정 */
  top: 20px; /* 화면 상단에서 20px */
  right: 20px; /* 화면 오른쪽에서 20px */
  z-index: 1000; /* 다른 요소 위에 표시되도록 설정 */
}

.excel-download-btn {
  background-color: #007bff; /* 파란색 버튼 */
  color: white; /* 텍스트 색상 */
  border: none;
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
  margin-left: 5px;
  margin-top : -2px;
}

.excel-download-btn:hover {
  background-color: #0056b3; /* 호버 시 색상 */
}

.summary-container {
  max-width: 100%;
  overflow-x: auto; /* 가로 스크롤 가능하도록 설정 */
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9fafc;
  padding: 15px;
}

.summary-container h4 {
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.overall-summary-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.overall-summary-table th,
.overall-summary-table td {
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 12px;
}

.overall-summary-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.overall-summary-table td {
  font-size: 12px;
  font-weight: bold;
}
/* 평균 컬럼을 검게 */
.avg-score {
  background-color: #f4f4f4; /* 검은색 배경 */
  font-weight: bold; /* 글씨 굵게 */
}

/* 🔵 통계 테이블 컨테이너 (여기서만 스크롤 발생) */
.stats-table-container {
  max-height: 600px; /* 📌 통계 테이블의 최대 높이 지정 */
  overflow-y: auto; /* 📌 세로 스크롤만 활성화 */
  border: 1px solid #ddd;
}

.excel-announcement {
  font-weight: bold;   /* 볼드체 */
  font-size: 17px;     /* 17px 폰트 */
  text-align: right;   /* 오른쪽 정렬 */
  display: block;      /* span은 인라인 요소라, 정렬 적용하려면 block/inline-block 필요 */
}
</style>




